var _style, _polyline, _polyline2, _polyline3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5596E6;stroke-width:0.85;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#5596E6;stroke-width:0.85;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_512_",
    className: "st0",
    points: "27.2,6.8 16,0.7 2.8,7.9 16,16 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_513_",
    className: "st0",
    points: "18,30.3 29.3,24.2 29.3,7.9 16,16 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_511_",
    className: "st0",
    points: "2.8,9.9 2.8,24.2 16,31.3 16,16 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16,
    cy: 16,
    r: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainers);
export default __webpack_public_path__ + "../static/product-explorer/assets/containers.c10dc61a3682f56652f7c2de50067c63.svg";
export { ForwardRef as ReactComponent };